import { Button } from '@/components/Button'

interface DetailHeaderProps {
	backLabel?: string
	onBack?: () => void
	onShare?: () => void
	className?: string
}

export function DetailHeader ({
	backLabel = 'Back to Search',
	onBack,
	onShare,
	className = ''
}: DetailHeaderProps) {
	return (
		<div
			className={`spaces-detail-header spaces:flex spaces:items-center spaces:justify-between spaces:p-12 spaces:border-b spaces:border-canvas-3 spaces:bg-canvas-base ${className}`}
		>
			<Button
				label={backLabel}
				iconLeft='CaretLeft'
				appearance='ghost'
				color='content2'
				size='md'
				spacesClass='spaces-back'
				onClick={onBack}
			/>
			{onShare && (
				<Button
					label='Share'
					iconRight='Share'
					appearance='ghost'
					color='content3'
					size='md'
					spacesClass='spaces-share'
					onClick={onShare}
				/>
			)}
		</div>
	)
}
